import { Box } from '@mui/material';

type GroupMessageEmailTemplateViewProps = {
  body: string;
};

export const GroupMessageEmailTemplateView = (props: GroupMessageEmailTemplateViewProps) => {
  const { body } = props;

  return (
    <Box
      component='iframe'
      title='Email template preview'
      srcDoc={body}
      sandbox=''
      sx={{
        width: '100%',
        height: '25rem',
      }}
    />
  );
};
